export default __webpack_public_path__ + "static/media/Path3475.97099ad3.svg";